
/*
* 公司
*/

<template>
  <div class="hbn-container" id="userInfo">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="专区名称">
                  <el-input
                    v-model="PageQuery.queryModel.name"
                    placeholder="专区名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select clearable v-model="PageQuery.queryModel.status">
                    <el-option label="启用" :value="true" />
                    <el-option label="禁用" :value="false" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          :icon="Search"
          @click="add"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="450"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              show-overflow-tooltip
              title="专区名称"
              field="name"
              align="center"
            ></vxe-table-column>
            <vxe-table-column
              show-overflow-tooltip
              title="类型"
              field="type"
              align="center"
            >
              <template #default="{ row }">
                {{ row.type === 1 ? "其他类型" : "课程类型" }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              show-overflow-tooltip
              title="优先级"
              field="priority"
              align="center"
            ></vxe-table-column>
            <vxe-table-column
              show-overflow-tooltip
              title="创建时间"
              field="creationTime"
              align="center"
              :formatter="formatterData"
            >
            </vxe-table-column>
            <vxe-table-column
              show-overflow-tooltip
              title="修改时间"
              field="lastModificationTime"
              align="center"
              :formatter="formatterData"
            ></vxe-table-column>
            <vxe-table-column
              show-overflow-tooltip
              title="状态"
              field="status"
              align="center"
            >
              <template #default="{ row }">
                <el-switch
                  v-model="row.status"
                  size="small"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="onStatusChange($event, row)"
                />
              </template>
            </vxe-table-column>
            <vxe-table-column
              width="150"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ row }">
                <el-button type="text" size="small" @click="onRowEdit(row)"
                  >编辑</el-button
                >
                <el-popconfirm
                  v-if="!row.status"
                  title="是否要删除?"
                  @confirm="onRowDelete(row)"
                >
                  <template #reference>
                    <el-button size="small" type="text">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
    <CustomizedZoneEdit
      ref="CompanyEdit"
      :rowId="rowId"
      v-if="dialogVisible"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></CustomizedZoneEdit>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
import {
  getDataByPageQuery,
  changeHomePageStatus,
  deleteHomePage,
} from "@api/Basic";

import CustomizedZoneEdit from "@comp/Basic/CustomizedZoneEdit.vue";
import { dateFormat } from "@/util/utils.js";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
          status: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      dialogVisible: false,
      show: false,
      DataList: [],
      rowId: 0,
    };
  },
  components: {
    CustomizedZoneEdit,
    Search,
  },
  methods: {
    // 编辑
    onRowEdit(row) {
      this.rowId = row.id;
       this.dialogVisible = true;
    },
    // 删除
    onRowDelete(row) {
      deleteHomePage(row.id).then((res) => {
        if (res) {
          this.$message.success("删除成功");
          this.PageQuery.pageindex = 1;
          this.GetData();
        }
      });
    },
    formatterData: function ({ cellValue, row, column }) {
      return dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
    },
    add() {
      this.rowId = 0;
      this.dialogVisible = true;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    // 状态改变
    onStatusChange(e, row) {
      row.status = e;
      changeHomePageStatus(row).then((res) => {
        this.GetData();
      });
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    GetData() {
      const _this = this;
      try {
        getDataByPageQuery(JSON.stringify(this.PageQuery)).then(function (
          data
        ) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
  },
  created() {
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
@import "@/common/css/Hbn_modules/hbn-base-model";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>
<style scoped>
</style>
